<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="localAttraction.id > 0; else addTitle">Edit Local Attraction</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <fieldset class="fieldset-container">
        <legend>Attraction Basics</legend>
        <p>
          <mat-form-field class="edit-local-attraction__wideField">
            <input matInput
                   placeholder="Attraction Name *"
                   formControlName="name"
                   [(ngModel)]="selectedName">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field>
            <mat-select placeholder="Attraction Type *" [(value)]="selectedTravelType" name="type" formControlName="type">
              <mat-option value="Accommodations">Accommodations</mat-option>
              <mat-option value="Attractions">Attraction</mat-option>
              <mat-option value="Museum">Museum</mat-option>
              <mat-option value="National Park">National Park</mat-option>
              <mat-option value="Restaurant Nearby">Restaurant Nearby</mat-option>
              <mat-option value="Restaurant On Field">Restaurant On Field</mat-option>
              <mat-option value="State or Local Park">State or Local Park</mat-option>
              <mat-option value="Transportation">Transportation</mat-option>
            </mat-select>
          </mat-form-field>
        </p>
      </fieldset>
      <fieldset class="fieldset-container">
        <legend>Attraction Contact Information</legend>
        <p>
          <mat-form-field>
            <input #phone matInput
                   placeholder="Phone"
                   formControlName="phone"
                   [(ngModel)]="selectedPhone"
                   maxlength="14"
                   (blur)="phoneFieldBlur('phone')"
                   (keyup)="phoneFieldKeyUp($event, 'phone', phone)">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-local-attraction__wideField">
            <input matInput
                   placeholder="Website"
                   formControlName="website"
                   [(ngModel)]="selectedWebsite">
          </mat-form-field>
        </p>
      </fieldset>
      <!-- <p>
        <mat-form-field class="edit-local-attraction__wideField">
          <input matInput
                 placeholder="Address * (Street Address, City, State, ZIP)"
                 formControlName="address"
                 [(ngModel)]="selectedAddress">
        </mat-form-field> -->
      <fieldset class="fieldset-container">
        <legend>Attraction Address</legend>
        <p>
          <mat-form-field class="edit-local-attraction__wideField">
            <input matInput
                   placeholder="Street *"
                   formControlName="street1"
                   [(ngModel)]="selectedStreet1">
          </mat-form-field>
        </p>
        <p class="input address_line_row">
          <mat-form-field class="address_row_item cityField">
            <input matInput
                   placeholder="City *"
                   formControlName="city"
                   [(ngModel)]="selectedCity">
          </mat-form-field>
          <mat-form-field *ngIf="states.length" class="address_row_item">
            <mat-select formControlName="state" placeholder="Select State *" [(ngModel)]="selectedState">
              <mat-option value="">None</mat-option>
              <mat-option *ngFor="let state of states" value="{{state.stateCode}}">{{state.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="!states.length" class="address_row_item">
            <input matInput
                   placeholder="Enter State"
                   formControlName="state"
                   [(ngModel)]="selectedState">
          </mat-form-field>
          <mat-form-field class="address_row_item">
            <input matInput
                   placeholder="{{postalCodePlaceHolder}}"
                   formControlName="zip"
                   [(ngModel)]="selectedZip">
          </mat-form-field>
          <mat-form-field>
            <mat-select [id]="1" formControlName="country" placeholder="Select Country"
                        (selectionChange)="countryChange($event)" [(ngModel)]="selectedCountry">
              <mat-option value="">None</mat-option>
              <mat-option *ngFor="let country of countries" value="{{country.countryCodeIso2.trim()}}">
                {{country.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </p>
      </fieldset>
      <fieldset class="fieldset-container">
        <legend>Attraction Location</legend>
        <p>Drag and drop map marker to change location or click the button to set it to the address above.</p>
        <p>
          <button class="mat-raised-button submit-button edit-local-attraction__button-spacing" [disabled]="!hasAddress()" (click)="setMarkerToAddress()">
            Set Map Marker to Attraction Address
          </button>
        </p>
        <p>
          <agm-map #popupMap class="edit-local-attraction__chart" [zoom]="17" [usePanning]="true"
                   [mapTypeControl]="true" [fullscreenControl]="true"
                   [mapTypeControlOptions]="{ position: 6, mapTypeIds: [ 'roadmap', 'satellite' ]}" >
            <agm-marker *ngIf="latlon" [latitude]="latlon.lat"
                        [longitude]="latlon.lon"
                        [markerDraggable]="true" (dragEnd)="pinDropped($event)"></agm-marker>
          </agm-map>
        </p>
      </fieldset>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Local Attraction
</ng-template>
